package ui.settings

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.LocalUriHandler
import cafe.adriel.voyager.core.annotation.InternalVoyagerApi
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.transitions.FadeTransition
import com.essntl.config.EssntlConfig
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import navigation.home.settings.BackofficeSettingsScreenNav
import navigation.settings.SettingsState
import navigation.settings.areascountries.AreasCountriesScreeNav
import navigation.settings.categoriestags.CategoriesTagsScreenNav
import navigation.settings.currency.CurrencyScreenNav
import navigation.settings.datetime.DateTimeScreenNav
import navigation.settings.general.GeneralScreenNav
import navigation.settings.imagegallery.ImageGalleryScreenNav
import navigation.settings.paymentparameter.paymentparameter.PaymentParameterScreenNav
import navigation.utils.safeReplaceAll
import ui.settings.components.SettingsNavBar

@OptIn(InternalVoyagerApi::class)
@Composable
fun SettingsScreen(
    state: SettingsState,
    onRefresh: (() -> Unit) -> Unit,
) {
    var selectedNavItem by rememberSaveable {
        mutableStateOf(SettingsNavItem.ImageGallery)
    }

    Navigator(
        PaymentParameterScreenNav(onRefresh),
    ) { navigator ->

        LaunchedEffect(selectedNavItem) {
            val screen = when (selectedNavItem) {
                SettingsNavItem.Payments ->
                    PaymentParameterScreenNav(onRefresh)

                SettingsNavItem.CategoriesTags ->
                    CategoriesTagsScreenNav(onRefresh)

                SettingsNavItem.AreasCountries ->
                    AreasCountriesScreeNav(onRefresh)

                SettingsNavItem.DateTime ->
                    DateTimeScreenNav(onRefresh)

                SettingsNavItem.Currency ->
                    CurrencyScreenNav(onRefresh)

                SettingsNavItem.ImageGallery ->
                    ImageGalleryScreenNav(onRefresh)

                SettingsNavItem.General ->
                    GeneralScreenNav(onRefresh)

                SettingsNavItem.Backoffice ->
                    BackofficeSettingsScreenNav(onRefresh)
            }

            navigator.safeReplaceAll(screen)
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier
                .fillMaxSize()
                .padding(vertical = 1.spacing),
        ) {
            SettingsNavBar(
                state = state,
                selectedItem = selectedNavItem,
                onItemSelected = { selectedNavItem = it },
            )

            Column(
                modifier = Modifier.fillMaxSize(),
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                        .background(MaterialTheme.esColorScheme.bgSecondary)
                        .padding(
                            vertical = EsConstants.SectionVerticalPadding,
                            horizontal = EsConstants.SectionHorizontalPadding,
                        ),
                ) {
                    Text(
                        text = "Settings > ",
                        color = MaterialTheme.esColorScheme.textTertiary,
                        style = MaterialTheme.esTypography.h2Bold32,
                    )

                    Text(
                        text = selectedNavItem.title,
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.h2Bold32,
                    )
                }

                Spacer(modifier = Modifier.height(1.spacing))

                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                        .background(MaterialTheme.esColorScheme.bgSecondary)
                        .padding(
                            vertical = EsConstants.SectionVerticalPadding,
                            horizontal = EsConstants.SectionHorizontalPadding,
                        ),
                ) {
                    FadeTransition(navigator)
                }
            }
        }
    }
}
